<!-- 首页 -->
<!-- 搜索 + ... -->
<template>
  <div id="home">
    <!-- <search /> -->
    <div class="main-button">
      <el-button @click="gotoSearch">捐赠查询</el-button>
      <el-button @click="gotoCertificate">证书查询</el-button>
    </div>
    <div class="main width1200">
      <div v-for="s in stage" v-bind:key="s.id" class="row">
        <div class="title">
          <i class="el-icon-time"></i>
          <span class="margin-left">{{ s.years }}</span>
          <span class="margin-left">{{ s.name }}</span>
        </div>
        <ul>
          <li v-for="t in s.types" v-bind:key="t.id" class="item">
            <a v-if="t.events[0]" :href="'/#/activity/' + t.events[0].id"><img class="img" :src="t.logoUrl" /></a>
            <a v-else href="/#/"><img class="img" :src="t.logoUrl" /></a>
            <div class="description">
              <a v-if="t.events[0]" :href="'/#/activity/' + t.events[0].id"><div class="name"><span>{{ t.title }}</span></div></a>
              <div v-else class="name"><span>{{ t.title }}</span></div>
              <div class="ename"><span>{{ t.eTitle }}</span></div>
              <span class="split"> </span>
              <div class="memo">{{ t.description }}</div>
            </div>
          </li>
          <!-- <li class="item">
            <img class="img" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1539875433690&di=42a5edc3a23c4f8cc60b87519a9850b4&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201310%2F26%2F20131026103918_jyiyL.jpeg" />
            <div class="description">
              <div class="name"><span>物资捐赠</span></div>
              <div class="ename"><span>BUILD SCHOOLS</span></div>
              <span class="split"> </span>
              <div class="memo">爱心会向位于大山深处贫困地区的小学学校提供资金支持，为学校通水，接点，增照明。保证学生拥有能遮风挡雨的最基本读书观景</div>
            </div>
          </li>
          <li class="item">
            <img class="img" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1539875433690&di=42a5edc3a23c4f8cc60b87519a9850b4&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201310%2F26%2F20131026103918_jyiyL.jpeg" />
            <div class="description">
              <div class="name"><span>物资捐赠</span></div>
              <div class="ename"><span>BUILD SCHOOLS</span></div>
              <span class="split"> </span>
              <div class="memo">爱心会向位于大山深处贫困地区的小学学校提供资金支持，为学校通水，接点，增照明。保证学生拥有能遮风挡雨的最基本读书观景</div>
            </div>
          </li>
          <li class="item">
            <img class="img" src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1539875433690&di=42a5edc3a23c4f8cc60b87519a9850b4&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201310%2F26%2F20131026103918_jyiyL.jpeg" />
            <div class="description">
              <div class="name"><span>物资捐赠</span></div>
              <div class="ename"><span>BUILD SCHOOLS</span></div>
              <span class="split"> </span>
              <div class="memo">爱心会向位于大山深处贫困地区的小学学校提供资金支持，为学校通水，接点，增照明。保证学生拥有能遮风挡雨的最基本读书观景</div>
            </div>
          </li> -->
        </ul>
      </div>
    </div>
    <foote />
  </div>
</template>

<script>
import search from './Search'
import foote from './Footer'
import { activities } from '@/api'

export default {
  name: 'home',
  components: {
    search,
    foote
  },
  data () {
    return {
      stage: []
    }
  },
  methods: {
    getList () {
      activities().then(response => {
        if (response && response.data && response.data.success === true) {
          // this.list = response.data.data.records
          // this.total = response.data.data.total
          // this.listLoading = false
          // console.log(response.data)
          this.stage = response.data.data
        } else if (response && response.data && response.data.success === false) {
          // this.listLoading = false
          // this.$message({
          //   type: 'error',
          //   message: '查询失败'
          // })
        }
      })
    },
    gotoSearch () {
      this.$router.push({ path: this.redirect || '/search/' })
    },
    gotoCertificate () {
      this.$router.push({ path: this.redirect || '/certificate/' })
    }
    // header (title) {
    //   if (title === '一帮一') {
    //     return '/images/t/1.jpg'
    //   } else if (title === '捐衣物') {
    //     return '/images/t/2.jpg'
    //   } else if (title === '改校舍') {
    //     return '/images/t/4.jpg'
    //   } else if (title === '物资捐赠') {
    //     return '/images/t/3.jpg'
    //   } else if (title === '乡村书院') {
    //     return '/images/t/5.jpg'
    //   } else if (title === '点对点') {
    //     return '/images/t/6.jpg'
    //   } else {
    //     return '/images/t/5.jpg'
    //   }
    // }
  },
  created () {
    this.getList()
  }

}
</script>

<style lang="less">
  #home {
    /*height: 50px;*/
    /*padding-top: 13px; */
    background: #0d0d0d;
    .main-button {
      margin-top: 50px;
      margin-left: 300px;
      margin-right: 300px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .el-button {
        background-color: #ff7800;
        border-color: #ff7800;
        padding: 12px 50px;
        margin: 20px;
        span {
          color: #fff !important;
          font-size: 12pt;
        }
      }
    }
    .main{
      /*height: 30px;*/
      padding-top: 12px;
      // background: #0d0d0d;
      .row {
        margin-bottom: 12px;
        // background: #333;
        .title {
          line-height: 143px;
          font-size: 27px;
          margin: 0px;
          color: #fff;
          // background-color: #f00
          .margin-left {
            margin-left: 20px;
          }
        }
        ul {
          margin: 0px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            display: flex;
            justify-content: space-between;
            // background: #0f0;
            height: 169px;
            width: 545px;
            margin-bottom: 50px;
            .img {
              height: 169px;
              width: 300px;
              margin-right: 25px;
              border-radius: 5px;
            }
            .description {
              flex: 1;
              .name {
                line-height: 20px;
                font-size: 20px;
                color: #fff;
                // margin-bottom: 10px;
              }
              .ename {
                line-height: 25px;
                font-size: 12px;
                // font-weight: bold;
                color: #ff7800;
                // margin-bottom: 14px;
              }
              .split {
                display: block;
                width: 20px;
                height: 4px;
                background: #ff7800;
                margin-bottom: 32px;
              }
              .memo {
                font-size: 14px;
                color: #999;
                line-height: 22px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue